<template>
    <div class="form">
        <Form ref="info" :model="info" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem prop="cusType" label="租客身份">
                        {{ dict.cusType.val(info.cusType) }}
                    </FormItem>
                </Col>

                <Col span="12" v-if="info.cusType == 2">
                    <FormItem prop="cusMobile" label="修改时间">
                        {{ (info.createTime ? info.createTime : "") | ymdL }}
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="租客姓名">
                        {{ info.cusName }}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机号">
                        {{ info.cusMobile }}
                    </FormItem>
                </Col>
            </Row>
            <div v-if="info.cusType == 1">
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="性别">
                            {{ this.$enum.get("sex").getName(info.sex) }}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="证件类型">
                            {{
                                info.credType
                                    ? this.dict.credType.val(info.credType)
                                    : ""
                            }}
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="cusMobile" label="修改时间">
                            {{
                                (info.createTime ? info.createTime : "") | ymdL
                            }}
                        </FormItem>
                    </Col>
                </Row>
            </div>
            <div v-else>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="公司名称">
                            {{ info.comName }}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="公司电话">
                            {{ info.comTel }}
                        </FormItem>
                    </Col>
                </Row>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="addr" label="公司地址">
                            {{ info.addr }}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税号">
                            {{ info.taxNum }}
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="addr" label="开户银行">
                            {{ info.bank }}
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="银行账号">
                            {{ info.account }}
                        </FormItem>
                    </Col>
                </Row>
            </div>
        </Form>
    </div>
</template>

<script>
import { updatelogView } from "@/api/contract";
import Dict from "_u/dict";
import { ymdL } from "_u/helper";

export default {
    props: {
        id: {
            type: [String, Number],
            default: "",
        },
    },

    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            info: {
                id: "", // 租户数据编号
                contractId: "", // 合同编号编号
                cusType: "", // 客户类型
                cusId: "", // 客户数据编号
                cusName: "", // 客户姓名
                cusMobile: "", // 客户手机号
                sex: "", // 性别
                credType: "", // 证件类型
                credNo: "", // 证件号码
                comName: "", // 公司名称
                comTel: "", // 公司电话
                taxNum: "", // 税号
                addr: "", // 公司地址
                bank: "", // 开户银行
                account: "", // 银行账户
                createTime: "",
            },
            dict: {
                cusType: Dict.NULL,
                credType: Dict.NULL,
            },
        };
    },
    mounted() {
        var $info = this.$refs.info;
        // 按钮配置
        var btns = [{ type: "default", text: "关闭", name: "cancel" }];
        this.$modal.updateBtns(btns);
        this.$modal.beforeEnter((next) => {
            Promise.all([
                Dict.get(["cus_type", "cred_type"]),
                updatelogView(this.id),
            ])
                .then((args) => {
                    var [dictGroup, view] = args;
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });

                    // Object.keys(view.data.e).forEach((value) => {
                    //     this.info[value] = this.customer[value];
                    // });
                    if (view) {
                        var viewData = view.data;
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity;

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        );
                    }
                })
                .finally(() => {
                    next();
                });
        });
    },
    created() {
        console.log(this.id);
    },
};
</script>

<style lang="scss" scoped>
</style>